<p-confirmDialog key="modify" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Options-->
<div class="MainGrid2Col">
	<h4 style="grid-column: 1 / 3; margin-bottom: 5px; text-align: center">Meal Type</h4>

	<!--Pick School or District When Adding-->
	<label *ngIf="EditMode == false">Add to:</label>
	<div *ngIf="EditMode == false && IsDistrictUser == true" class="RadioGrid">
		<input type="radio" name="SchoolOpt" id="School" value="School" [(ngModel)]="SchoolOpt" />
		<label for="School">{{ SchoolName }}</label>

		<input style="margin-left: 10px" type="radio" name="SchoolOpt" id="District" value="District" [(ngModel)]="SchoolOpt" />
		<label for="District">District</label>
	</div>

	<!--School is Read-Only in Edit Mode-->
	<label *ngIf="EditMode == true">School:</label>
	<label *ngIf="EditMode == true || (EditMode == false && IsDistrictUser == false)" class="InfoText">{{ SchoolName }}</label>

	<label>Meal Name:</label>
	<input class="form-control" type="text" placeholder="Meal Name ex. B Lunch" [(ngModel)]="MealName" />

	<label>Start Time:</label>
	<p-calendar timeOnly="true" [(ngModel)]="StartTime" hourFormat="12" name="txtStartTime"></p-calendar>

	<label>End Time:</label>
	<p-calendar timeOnly="true" [(ngModel)]="EndTime" hourFormat="12" name="txtEndTime"></p-calendar>

	<label>Base Price:</label>
	<input placeholder="Ex. 3.50" class="form-control" type="number" min="0" step="0.1" [(ngModel)]="MealPrice" />
</div>

<!--Subsidy Pricing-->
<div class="SubsidyDiv">
	<caass-subsidy-pricing-table [MealID]="MealID"> </caass-subsidy-pricing-table>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">
		{{ EditMode == true ? "Update" : "Add" }}
	</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
